import { isImpersonating } from "@/contexts/AuthContext";
import { formatCurrencyToApi } from "@/utils";

const WITHDRAW_ROLES = ["SELLER_FINANCES", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_WITHDRAWAL"];

interface BalanceData {
    amount?: string;
    provisionedAmount?: string;
}

function parseStorage(key: string) {
    return JSON.parse(localStorage.getItem(key) || "null");
}

function isZeroAmount(value?: string): boolean {
    return (formatCurrencyToApi(value) || 0) === 0;
}

export function hasWithdrawPermission(): boolean {
    const user = parseStorage("barte-user-info");
    const featureToggle = parseStorage("barte-features-list-user");
    const hasWithdrawRole = WITHDRAW_ROLES.some((role) => user?.roles?.includes(role));
    return Boolean(hasWithdrawRole && featureToggle?.includes("view_seller_finance"));
}

export function hasNoBalance(data?: BalanceData): boolean {
    return isZeroAmount(data?.amount) && isZeroAmount(data?.provisionedAmount);
}

export function isWithdrawDisabled(data: BalanceData | undefined, canWithdraw: boolean): boolean {
    return hasNoBalance(data) || !canWithdraw;
}

export function canViewTransferList(canWithdraw: boolean): boolean {
    return canWithdraw || isImpersonating();
}
